<template>
  <div>

    <contador v-if="contadores.length > 0 && show_contadores" :list_contadores="contadores" />

    <b-card>
      <!-- User Interface controls -->
      <div class="row justify-content-between my-2" v-if="show_search">
        <div class="col-md-4">
          <div class="input-group mb-2">
            <div class="input-group-prepend" style="width: 100%">
              <!-- <div class="input-group-text"><i class="fas fa-search"></i></div> -->
              <input type="search" class="form-control" placeholder="Pesquisar" v-model="params.search"
                @keyup="setSearch()" />
            </div>
          </div>
        </div>
        <div class="col-md-4" v-if="parceiro.is_ar && show_filter_parceiros">
          <e-select :route="`parceirosSelect${custom_params.uf ? '/' + custom_params.uf : ''}`"
            :custom_option="{ text: 'nenhum', value: '' }" holder="Filtrar por parceiro" v-model.number="parceiro_id"
            @input="
              filterSelect({
                value: $event,
                name: 'cliente:user_id',
              })
            ">
          </e-select>
        </div>
        <slot name="header"></slot>
        <div class="col-md-4 d-flex justify-content-end align-items-center" v-if="show_buttons" v-once>
          <b-button-group size="sm">
            <b-button v-for="(btn, idx) in buttons" :key="idx" :pressed.sync="btn.state" variant="secondary"
              @click.prevent="actionButton(btn)">
              <i :class="`fas fa-${btn.icon}`"></i>
              {{ btn.text }}
            </b-button>
          </b-button-group>
        </div>
      </div>
      <!-- Main table element -->
      <b-table :id="id" class="e-Table" ref="table" :sticky-header="height" :stacked="stacked" hover
        @sort-changed="sortingChanged" no-local-sorting empty-text="Não foi encontrado nenhum registro!" bordered
        :items="items" :fields="columns" :busy="isBusy" show-empty small>

        <template #thead-top="data" v-if="show_filters">
          <b-tr style="z-index: 9;
    position: relative;">
            <b-th v-for="(field, field_index) in data.fields" :key="field_index">

              <e-select v-model="selected[field_index].value" @input="filterSelect({ value: $event, name: field.key })"
                holder="Filtrar" :custom_option="{ text: 'TODOS', value: '' }"
                :route="field.filter.route" v-if="field.filter">
              </e-select>
            </b-th>
          </b-tr>
        </template>

        <template #head()="row">
          <slot :name="row.label" :row="row.label">
            <div class="d-flex align-items-center"><span v-html="row.label"></span></div>
          </slot>
        </template>

        <template #cell()="row">
          <slot :name="row.field.key" :row="row.item">
            <div class="d-flex align-items-center" v-html="row.item[row.field.key]"></div>
          </slot>
        </template>

        <template #row-details="row">
          <b-card>
            <ul>
              <li v-for="(value, key) in row.item" :key="key">
                {{ key }}: {{ value }}
              </li>
            </ul>
          </b-card>
        </template>

        <template #table-busy>
          <div class="text-center text-dark my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>

        <template #custom-foot>
          <b-tr>
            <b-td :colspan="columns.length" variant="secondary" class="text-right">
              <div class="text-center text-dark my-2" v-if="loading && stacked">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Carregando...</strong>
              </div>

              <div class="text-center my-2" v-else-if="!loading && !isBusy && show_results">
                Mostrando
                {{ items && items.length ? items.length : 0 }} resultados
              </div>
              <div v-observe-visibility="visibilityChanged" class="my-2" v-if="infiniteScroll && !isBusy"></div>

            </b-td>
          </b-tr>
        </template>
      </b-table>

      <div class="text-center text-dark my-2" v-if="loading && stacked">
        <b-spinner class="align-middle"></b-spinner>
        <strong>Carregando...</strong>
      </div>
      <div class="text-center my-2" v-else-if="!loading && !isBusy && stacked && show_results">
        Mostrando
        {{ items && items.length ? items.length : 0 }} resultados
      </div>
      <div v-observe-visibility="visibilityChanged" class="my-2" v-if="infiniteScroll && stacked && !isBusy"></div>
    </b-card>
  </div>
</template>

<script>
import contador from "./Contador.vue";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  components: { contador },
  props: {
    id: { required: true },
    prefix: { type: String, default: "" },
    height: { type: String, default: "70vh" },
    columns: { type: Array, required: true },
    url: { type: String, required: true },
    length: { type: Number, default: 50 },
    infiniteScroll: { type: Boolean, default: true },
    show_search: { type: Boolean, default: true },
    show_filter_parceiros: Boolean,
    show_results: { type: Boolean, default: true },
    show_contadores: { type: Boolean, default: true },
    show_filters: { type: Boolean },
    show_buttons: [Array, Boolean],
    custom_params: {
      type: Object,
      default: () => { },
    },
    initial_filter: { type: Array, default: () => [] },
  },
  data() {
    return {
      parceiro_id: null,
      selected: [],
      windowWidth: window.innerWidth,
      stacked: false,
      search_interval: null,
      isBusy: true,
      first_load: true,
      items: [],
      withInitialFilter: false,
      contadores: [],
      totalRows: 1,
      sortBy: "",
      loading: false,
      sortDesc: false,
      params: {
        page: 1,
        length: this.length,
        search: null,
      },
      sortDirection: "asc",
      filter: null,
      buttons: [
        {
          title: "Exportar",
          text: "Exportar",
          color: "secondary",
          mutation: {
            path: "datatable/exportar",
          },
          icon: "download",
          state: false,
          status: true,
        },
      ],
    };
  },
  watch: {
    'params.search': function (newVal, oldVal) {
      if (oldVal && !newVal) {
        this.params.page = 1;
        this.params.search = null;
        this.params.filter = [];
        this.items = [];
        this.first_load = true;
        this.getItems();

      }
    },
    parceiro_id(newVal) {
      if (newVal == '')
        this.parceiro_id = null;
    },
    current_params(state) {
      console.log("current_params", state);
      if (!state.search)
        this.params.search = null;




      const self = this;
      this.selected.map(function (item, index) {

        //  console.log("selected", item, index);


        if (state && state.filter) {

          console.log("filter", state.filter);
          let indexFilter = state.filter.findIndex((filter) => filter.name == item.name && filter.value == item.value);

          //  if (indexFilter != -1 && self.on_click) {

          self.selected[index].value = null;

          //  self.selected[index] = Object.assign(self.selected[index], self.selected[index].value = "") ;


          self.resetOnclick();
          // }
        }

      });

    },
    reload(state) {
      if (state) {
        this.getItems();
      }
    },

  },
  created() {
    const self = this;
    this.columns.map((field, index) => {
      self.selected[index] = { name: field.key, value: null };
    });
    this.setId(this.id);
    this.getItems();




    window.addEventListener("resize", this.onResize);
    this.onResize();
  },
  computed: {
    ...mapState("user", ["user", "parceiro"]),
    ...mapState("datatable", [
      "reload",
      "reset",
      "on_click",
      "current_params",
      "is_external_params",
    ]),
    sortOptions() {
      // Create an options list from our columns
      return this.columns
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    ...mapMutations("datatable", ["setId", "setParams", "setExternalParams", "setReload", "resetOnclick", "filterSelect"]),
    ...mapActions("api", ['CANCEL_PENDING_REQUESTS']),
    async getItems($loading = false) {

      this.$root.$emit('bv::hide::popover');

      if (this.$route.query && this.$route.query.params) {
        this.setExternalParams(true);
        this.setParams({ ...this.params, ...this.$route.query.params });
      } else if (this.reload) {

        //  this.isBusy = true;
        this.setParams({ ...this.params, ...this.current_params });
      } else {

        if (this.first_load) {
          this.setParams({ ...this.params, ...this.custom_params });
          this.first_load = false;
        } else {
          this.setParams({ ...this.current_params, ...this.params });
        }

        if (!$loading) {
          this.isBusy = true;
        } else {
          this.loading = true;
        }
      }



      const result = await this.$api.get(this.url, {
        baseURL: document.location.protocol + "//" + document.location.hostname + "/api/" + this.prefix,
        params: this.current_params,
      });
      //this.items = result.data;

      this.lastPage = result.data.last_page;

      let items = result.data.data;


      this.params.page = result.data.current_page;

      if (result.data.extra_data && result.data.extra_data.contadores)
        this.contadores = result.data.extra_data.contadores;


      if (this.reload) {

        this.items = items;

        this.setReload(false);

        $('.b-table-sticky-header').animate({ scrollTop: 0 }, 'slow');

      } else if (this.items.length > 0 && !this.params.search) {
        this.items = [...this.items, ...items];

      } else {
        this.items = items;
      }

      this.loading = false;
      this.isBusy = false;




      if (this.is_external_params) {
        this.setExternalParams(false);
        this.$router.replace({ 'query': null });
      }

      // Here we could override the busy state, setting isBusy to false
      // this.isBusy = false
    },



    sortingChanged(ctx) {

      this.setParams({
        ...this.current_params, ...{
          order: { name: ctx.sortBy, sort: (ctx.sortDesc) ? 'asc' : 'desc' }
        }
      })
      this.setReload(true);

    },
    visibilityChanged(isVisible) {
      if (!isVisible) return;

      if (this.items && this.items.length >= 15) {

        if (this.params.page < this.lastPage && !this.reload) {
          this.params.page = this.params.page + 1;
          this.getItems(true);
        }
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth;

      if (this.windowWidth <= 800) {
        this.stacked = true;
      } else {
        this.stacked = false;
      }
    },
    setSearch() {

      if (this.params.search && this.params.search.length > 0) {

        this.params.page = 1;
        this.params.filter = [];

        this.setParams({ ...this.current_params, ...this.params });

        clearTimeout(this.search_interval);
        const self = this;
        this.search_interval = setTimeout(function () {
          self.CANCEL_PENDING_REQUESTS();
          self.getItems();
        }, 1000); //
      }

    },
    search() {

    },
    actionButton(button) {
      if (!!button.mutation) {
        if (!!button.mutation.params) {
          this.$store.commit(`${button.mutation.path}`, button.mutation.params);
        } else {
          this.$store.commit(`${button.mutation.path}`);
        }
      }

      if (!!button.action) {
        if (!!button.action.params) {
          this.$store.dispatch(`${button.action.path}`, button.action.params);
        } else {
          this.$store.dispatch(`${button.action.path}`);
        }
      }
    },
    setCustomRouteParams(column) {
      if (this.custom_params) {
        if (
          Object.keys(this.custom_params).find(
            (item) => item == column.filter.custom_params
          )
        )
          return column.filter.custom_params
            ? "/" +
            this.custom_params[
            Object.keys(this.custom_params).find(
              (item) => item == column.filter.custom_params
            )
            ]
            : "";
      }
      return "";
    },
    filterByColumn(data) {
      /*  state.data = [];
            let filter_index = state.params.filter.findIndex((o) => o.name === data.name);
            state.loading = true;

            if (filter_index != -1) {
                if (data.value) {
                    state.params.filter[filter_index] = {
                        name: data.name,
                        value: data.value,
                    };
                } else {
                    state.params.filter.splice(filter_index, 1);
                }
            } else {
                state.params.filter.push({ name: data.name, value: data.value });
            } */
      //  this.dispatch('datatable/setReload');
    },
  },
};
</script>
